import React from 'react';
import { FormattedDate } from 'react-intl';
import { IconButton } from '@nike/nike-design-system-components';
import { Delete } from '@nike/nike-design-system-icons';

import StatusToolTip from './StatusToolTip';
import { Currency } from '../../components/';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { VALUE_NA } from '../../shop/constants';

export const getReturnStatusColumns = (departments, isUnsubmittedReturns) => {
  const columns = [
    {
      header: <TranslatedCopy id='returnStatus.authNumber' />,
      id: 'returnAuthorizationId',
      cell: returnItem => returnItem.returnAuthorizationId || VALUE_NA
    },
    {
      header: <TranslatedCopy id='global.department' />,
      id: 'departmentName',
      cell: returnItem =>
        departments?.find(dept => dept.customerDepartmentCode === returnItem.departmentNumber)
          ?.customerDepartmentName || VALUE_NA
    },
    {
      header: <TranslatedCopy id='returnStatus.returnReference' />,
      id: 'referenceId'
    },
    {
      header: <TranslatedCopy id='returnStatus.creditType' />,
      id: 'creditType',
      cell: returnItem =>
        returnItem.creditType ? (
          <TranslatedCopy id={`returnStatus.creditType.${returnItem.creditType.split('-').join('.').toLowerCase()}`} />
        ) : null
    },
    {
      header: <TranslatedCopy id='orderreturns.returnAmount' />,
      id: 'creditedAmount',
      cell: returnItem =>
        returnItem.creditedAmount ? (
          <Currency value={returnItem.creditedAmount} type={returnItem.currencyCode} />
        ) : (
          VALUE_NA
        )
    },
    {
      header: <TranslatedCopy id='global.submittedBy' />,
      id: 'createdBy',
      cell: returnItem =>
        returnItem.createdBy ? <span style={{ textTransform: 'lowercase' }}>{returnItem.createdBy}</span> : VALUE_NA
    },
    {
      header: <TranslatedCopy id='orderstatus.orderSubmittedDate' />,
      id: 'createTimestamp',
      cell: returnItem =>
        returnItem.createTimestamp ? <FormattedDate value={returnItem.createTimestamp} timeZone='utc' /> : VALUE_NA
    },
    {
      header: <TranslatedCopy id='returnStatus.dateExpires' />,
      id: 'expirationDate',
      cell: returnItem =>
        returnItem.expirationDate && <FormattedDate value={returnItem.expirationDate} timeZone='utc' />
    },
    {
      header: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <TranslatedCopy id='returnStatus.title' />
          <span style={{ alignSelf: 'center', marginLeft: '10px', color: 'white' }}>
            <StatusToolTip />
          </span>
        </div>
      ),
      id: 'status',
      cell: returnItem =>
        returnItem.status &&
        new TranslatedCopy({
          id: `returnStatus.returnStatus.${returnItem.status.split(' ').join('').toLowerCase()}`
        }).toString()
    }
  ];

  if (isUnsubmittedReturns) {
    columns.push({
      id: null,
      cell: (returnItem, { handleDeleteClick }) => (
        <IconButton
          size='small'
          appearance='secondary'
          Icon={<Delete aria-hidden title={new TranslatedCopy({ id: 'returnStatus.delete' }).toString()} />}
          style={{ backgroundColor: 'transparent', outline: 'none', padding: 0 }}
          onClick={e => handleDeleteClick(returnItem.id, e)}
        />
      )
    });
  }

  return columns;
};
